import { useChart } from '../components/Chart/ChartProvider';
import { usePageState } from '../components/PageState/PageStateProvider';

export const useSelectedPrimaryEntity = () => {
  const { pageState } = usePageState();
  const { item } = useChart();

  return pageState.primaryEntities[item?.id] ?? null;
};
